import React from "react";

import PickupSellerTable from "./table/PickupSellerTable";
import PickupBuyerTable from "./table/PickupBuyerTable";
import { useSelector } from "react-redux";

function Pickup() {
  const { accountType } = useSelector((state) => state.account);

  return (
    <div className="mt-1">
      <h3>Pickup Details</h3>
      {accountType === "industry" ? <PickupSellerTable /> : <PickupBuyerTable />}
    </div>
  );
}

export default Pickup;
